import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt'

const app = createApp(App)

const eventBus = mitt()

// we need to provide it to the app to be used globally
app.config.globalProperties.$bus = eventBus

app.mount('#app')